<template>
  <div class="flex-center">
    <div style="text-align: center">
      <div class="size-14" style="color: #000">{{ value.label }}</div>
      <div class="size-14" style="color: #000">기능을 추가하시겠습니까?</div>
      <div class="flex-align" style="margin-top: 28px">
        <button class="button is-grey" @click="cancelModal">취소</button>
        <button class="button is-primary" @click="confirm"
          style="width: 150px; margin-left: 6px">신청 및 상세보기</button>
      </div>
    </div>
  </div>
</template>

<script>


  export default {
    props: ['data'],
    components: {
    },
    data() {
      return {
        value: {
          label: '',
        },
      }
    },
    created() {
      this.value = this.data;

    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      },
    },
    methods: {
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      confirm() {
        this.$store.commit('cancelModal');
        let plugin = this.getPluginName(this.value.name);

        this.$root.$emit('appMarket', {plugin: plugin});
      },
      getPluginName(name) {
        return {
          phone: 'mobile_payment',
          trans: 'account_transfer',
          vbank: 'virtual_account',
          kakaopay: 'kakaopay'
        }[name];
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>

</style>
